
<div class="amplify-album">
  <div class="amplify-album-container">
    <amplify-s3-image-core
      class="amplify-image-container"
      *ngFor="let item of list"
      path="{{item.path}}"
      [options]="_options"
      (selected)="onImageSelected($event)"
    ></amplify-s3-image-core>
  </div>
</div>



// WEBPACK FOOTER //
// ./node_modules/aws-amplify-angular/dist/src/components/storage/s3-album-component/s3-album.component.core.d.ts.S3AlbumComponentCore.html